import {useCallback} from 'react';
import {TVoidFunction} from '../../../../../types';
import {ETargetAutoFill} from '../../../../RichText/types';
import {formatWithSymbols} from '../../../../../utils/insertIdTreeContent';

export const useFocusTarget = ({targetAutoFill, subjectInputRef, messageCursorLastPosition}) => {
    const handleFocusTarget = useCallback(
        (cb: TVoidFunction<string>, text: string) => {
            const isFocusSubject = targetAutoFill.current === ETargetAutoFill.SUBJECT;

            if (isFocusSubject) {
                const shortcode = formatWithSymbols(text);

                const subjectEl = subjectInputRef.current;
                const message = subjectInputRef.current.value;
                const position = messageCursorLastPosition.current;

                messageCursorLastPosition.current =
                    messageCursorLastPosition.current + shortcode.length;

                cb?.(
                    message.slice(0, position) + shortcode + message.slice(position, message.length)
                );

                subjectEl.focus();

                return false;
            }

            return true;
        },
        [messageCursorLastPosition, subjectInputRef, targetAutoFill]
    );

    return {handleFocusTarget} as const;
};
